import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { device } from '../../constants/StyledComponentConstants';
import Heading from './Heading';
import { FormattedMessage } from '../I18n';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { MY_PLAYLISTS_URL_FRAGMENT, WATCH_LATER_URL_FRAGMENT } from '../../constants/Navigation';
import { useRouteMatch } from 'react-router-dom';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { useCreatePlaylistModalPath } from '../../features/savedItems';
import UsageTracker from '../../utils/UsageTracker';
const CreatePlaylistButton = styled(UIRouterButton).withConfig({
  displayName: "SavedItemsLayout__CreatePlaylistButton",
  componentId: "r58fx2-0"
})(["@media screen and ", "{width:auto !important;margin-top:12px;margin-bottom:12px;}"], device.mobile);
const Separator = styled.div.withConfig({
  displayName: "SavedItemsLayout__Separator",
  componentId: "r58fx2-1"
})(["max-width:100px;width:100%;height:10px;flex:1;@media screen and ", "{display:none;}"], device.mobile);
export const useSavedItemsHeader = () => {
  const isWatchLater = useRouteMatch(WATCH_LATER_URL_FRAGMENT);
  const isMyPlaylists = useRouteMatch(MY_PLAYLISTS_URL_FRAGMENT);
  let titleKey = 'FAVORITES';
  let showCreatePlaylistButton = false;

  if (isWatchLater) {
    titleKey = 'WATCH_LATER';
  }

  if (isMyPlaylists) {
    titleKey = 'MY_PLAYLISTS';
    showCreatePlaylistButton = true;
  }

  return {
    showCreatePlaylistButton,
    titleKey
  };
};

const SavedItemsHeader = () => {
  const {
    titleKey,
    showCreatePlaylistButton
  } = useSavedItemsHeader();
  const createPlaylistModalPath = useCreatePlaylistModalPath();

  const onCreatePlaylistClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'create-playlist',
      location: 'playlist-page-header'
    });
  };

  return /*#__PURE__*/_jsx(Heading, {
    rightContent: showCreatePlaylistButton && /*#__PURE__*/_jsxs(UIFlex, {
      justify: "end",
      children: [/*#__PURE__*/_jsx(Separator, {}), /*#__PURE__*/_jsx(CreatePlaylistButton, {
        onClick: onCreatePlaylistClick,
        to: createPlaylistModalPath,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.savedItems.createPlaylist"
        })
      }), /*#__PURE__*/_jsx(Separator, {})]
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.heading.headingSubTitles.${titleKey}`
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.heading.headingTitles.${titleKey}`
    })
  });
};

const SavedItemsLayout = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SavedItemsHeader, {}), children]
  });
};

export default SavedItemsLayout;